'use client'

import React, { useEffect } from 'react'
import { motion } from 'motion/react'
import { useRouter } from 'next/navigation'
import { memberService } from '@/modules/member'
import { dialog } from '@/modules/ui/dialog'
import { moveToLoginPage } from '@/utils/moveToLoginPage'
import { usePurchaseInfo } from '@/hooks/purchase/usePurchaseInfo'
import { PurchaseItem } from '@/types/purchase.type'
import { memberStore } from '@/store/member.store'
import { homeActionLog } from '@/modules/action-log/home'

interface PurchaseButtonProps extends PurchaseItem {}

export const PurchaseButtonSection = () => {
  const { purchaseItemList, syncStorePurchaseItemList } = usePurchaseInfo()

  useEffect(() => {
    syncStorePurchaseItemList()
  }, [])

  return (
    <div className="fixed bottom-0 left-1/2 transform -translate-x-1/2 w-full pc:w-[512px] z-3">
      <div className="flex flex-col gap-[8px] mt-auto items-center mb-[20px]">
        {purchaseItemList.map((item, index) => (
          <PurchaseButton key={item.id} {...item} />
        ))}
      </div>
    </div>
  )
}

const PurchaseButton = ({
  id,
  productCode,
  name,
  price,
  productType,
  cardCount,
  discountType,
  discountValue,
  finalPrice,
  free,
}: PurchaseButtonProps) => {
  const router = useRouter()
  const finalPriceText = finalPrice.toLocaleString()
  const discountPriceText = price.toLocaleString()
  const { isUnder14 } = memberStore()

  const handleClickPurchasePage = async () => {
    homeActionLog.clickPurchase({ purchaseCount: cardCount, free })

    if (!memberService.isLogin()) {
      const confirmLogin = await dialog.openMessage({
        title: '로그인이 필요한 서비스입니다.',
        message: '로그인 하시겠습니까?',
        cancelVisible: true,
        confirmMessage: '네',
        cancelMessage: '아니오',
      })

      if (confirmLogin) {
        moveToLoginPage()

        return
      }

      return
    }

    if (isUnder14) {
      await dialog.openMessage({
        title: '14세 미만 고객은 구매가 불가능한 컨텐츠입니다.',
        confirmMessage: '확인',
      })

      return
    }

    router.push(`/purchase?productCode=${productCode}`)
  }

  // ${isProductCodeTypePack2 ? 'border-[2px] border-solid [border-image:linear-gradient(to_right,#C788EB,#E9C2F7,#86DCF9,#FFBEED)_1] rounded-md' : 'border-purple-2'}

  const isProductCodeTypePack2 = productCode === 'pack_2'

  return (
    <div className="relative w-full">
      <div
        className={`p-[2px] ml-[20px] mr-[20px] rounded-md overflow-hidden ${isProductCodeTypePack2 ? 'bg-gradient-to-r from-[#C788EB] via-[#E9C2F7] via-[#86DCF9] to-[#FFBEED]' : 'bg-purple-2'}`}
      >
        <div
          className={`flex relative h-[66px] min-w-[280px] px-4 pr-4 pl-6  justify-between items-center self-stretch rounded-md bg-purple-2`}
        >
          <div className="flex items-center gap-[16px]">
            <p className="text-white text-center  text-[20px] font-bold leading-[24px]">{cardCount}장</p>

            <div className="flex flex-col gap-[2px]">
              {discountType === 'RATE' && (
                <div className="flex items-center gap-[4px]">
                  <p className="text-[#ff97E3] text-center text-[12px] font-semibold leading-[16px]">
                    {discountValue}% 할인
                  </p>
                  <p className="text-gray-3 text-center text-[12px] font-normal leading-[16px] line-through">
                    {discountPriceText}원
                  </p>
                </div>
              )}
              <p className="text-[#CDD1D9]  text-[14px] font-normal leading-[16px]">{finalPriceText}원</p>
            </div>
          </div>
          <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 1.1 }}
            className="flex items-center justify-center gap-[10px] px-3 py-2 rounded bg-primary text-white text-center text-[14px] font-semibold leading-[16px] cursor-pointer z-4"
            onClick={handleClickPurchasePage}
          >
            구매하기
          </motion.button>
        </div>
      </div>
    </div>
  )
}
